import React, { useCallback, ComponentProps } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { tc } from '../../lib/trackingContext';
import { hrefFor } from '../../routers';
import { AmazonPayButton } from '../PaymentSourceButton';

type Props = Omit<ComponentProps<typeof AmazonPayButton>, 'onSelect'>;

export const CheckoutAmazonPayButton: React.FC<Props> = props => {
  const history = useHistory();
  const { pathname } = useLocation();

  const trackThirdParty = useCallback(() => {
    tc.track('Third Party Payment Method Flow Selected', {
      addToTrackingEvent: {
        payment_type: 'AMAZON',
        label: 'AMAZON'
      }
    });
  }, []);

  const handleOnClick = useCallback(() => {
    trackThirdParty();
    if (pathname !== hrefFor.CheckoutPage()) {
      history.push(hrefFor.CheckoutPage());
    }
  }, [history, pathname, trackThirdParty]);

  return <AmazonPayButton {...props} handleRedirect={handleOnClick} />;
};
